var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.093,
    height: 26.092,
    viewBox: "0 0 26.093 26.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.951,
    y1: 0.882,
    x2: 0.105,
    y2: 0.211,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_34",
    "data-name": "Union 34",
    d: "M8417,2962.045a13.046,13.046,0,1,1,13.045,13.047A13.059,13.059,0,0,1,8417,2962.045Zm2.079,0a10.966,10.966,0,1,0,10.966-10.966A10.979,10.979,0,0,0,8419.08,2962.045Zm10.673,5.628-1.7-3.629-3.632-1.7a1.041,1.041,0,0,1,.066-1.913l9.54-3.705a1.039,1.039,0,0,1,1.346,1.346l-3.705,9.54a1.043,1.043,0,0,1-.936.662l-.034,0A1.043,1.043,0,0,1,8429.753,2967.674Zm-2.252-6.184,1.771.831a1.026,1.026,0,0,1,.5.5l.833,1.772,1.973-5.075Z",
    transform: "translate(-8417.001 -2949)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoingIcon);
export default __webpack_public_path__ + "static/media/going-icon.97ac6255601bbd3b918941758c27191c.svg";
export { ForwardRef as ReactComponent };